exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ace_line_group[data-v-723cff9b]{text-align:left}.json-editor-container[data-v-723cff9b]{display:-ms-flexbox;display:flex;width:100%}.json-editor-container .tree-mode[data-v-723cff9b]{width:50%}.json-editor-container .code-mode[data-v-723cff9b]{-ms-flex-positive:1;flex-grow:1}.jsoneditor-btns[data-v-723cff9b]{text-align:center;margin-top:10px}.jsoneditor-vue .jsoneditor-outer[data-v-723cff9b]{min-height:150px}.jsoneditor-vue div.jsoneditor-tree[data-v-723cff9b]{min-height:350px}.json-save-btn[data-v-723cff9b]{background-color:#20a0ff;border:none;color:#fff;padding:5px 10px;border-radius:5px;cursor:pointer}.json-save-btn[data-v-723cff9b]:focus{outline:none}.json-save-btn[disabled][data-v-723cff9b]{background-color:#1d8ce0;cursor:not-allowed}code[data-v-723cff9b]{background-color:#f5f5f5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-723cff9b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-json-editor/vue-json-editor.vue
// module id = 938
// module chunks = 0